import React from "react";

const items = ["Mounjaro", "Tirzepatide", "Ozempic", "Semaglutide", "GLP‑1", "Doctor Supervised", "Weekly Injection", "Madinaguda"];

export const Marquee = () => {
  return (
    <section className="relative bg-[#779D7C] py-6 overflow-hidden">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {[...items, ...items, ...items].map((t, i) => (
          <span
            key={i}
            className="font-display italic text-2xl md:text-3xl text-[#E8F0E9] mx-10 md:mx-14 inline-flex items-center gap-10 md:gap-14"
          >
            {t}
            <span className="h-1.5 w-1.5 rounded-full bg-[#EB8771]" aria-hidden />
          </span>
        ))}
      </div>
    </section>
  );
};
